export const classNameMaxLength = 128;
